import React from "react";
import Header from "./Header";
import Hero from "./Hero"

const Home = () => {
  return (
    <>
      <div className="w-full h-fit">
        <Header/>
        <Hero/>
      </div>
    </>
  );
};

export default Home;
